import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import Header from './Header';
import Conversation from './Conversation';
import Answer from './Answer';

const Widget = () => {
  return (
    <div className="kil-chat-widget">
      <Header />
      <Conversation />
      <Answer />
    </div>
  );
}

export default Widget;